import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import { creditActionSchema, creditsBalanceResponseSchema } from "./schema";

export const creditsBalanceQuery = createQueryRequestDefinition({
  queryKey: ["credits-balance"],
  host: "cap-srv",
  path: "credits/org/balance",
  method: "POST",
  responseSchema: creditsBalanceResponseSchema,
});

export const creditActionsQuery = createQueryRequestDefinition({
  queryKey: ["credit-history"],
  host: "cap-srv",
  path: "/mirage-studio/org/credit-history",
  method: "GET",
  paramsSchema: z.object({
    lookbackDays: z.number().optional(),
  }),
  responseSchema: z.object({
    actions: z.array(creditActionSchema),
  }),
});
